import type { AnomalySection } from "@/lib/api/types.js";

/**
 * Two binary protocol flags shown above the methodology cards:
 *   - arithmetic_error: protocol identity broken — either actual voters
 *     ≠ invalid + null + Σ valid, or paper voters > paper ballots received
 *     (with the machine cohort excluded on hybrid forms).
 *   - vote_sum_mismatch: paper + machine ≠ total for at least one party
 *
 * Renders nothing when both are clear.
 */
export function BinaryFlags({ section: s }: { section: AnomalySection }) {
  if (!s.arithmetic_error && !s.vote_sum_mismatch) return null;

  return (
    <div className="space-y-1.5">
      {s.arithmetic_error ? (
        <div className="rounded-lg border border-score-high/20 bg-score-high/10 p-3">
          <div className="text-xs font-medium text-score-high">
            Аритметична грешка в протокола
          </div>
          <div className="mt-1 text-xs text-score-high">
            Общо гласували ≠ действителни + недействителни + бели
          </div>
        </div>
      ) : null}
      {s.vote_sum_mismatch ? (
        <div className="rounded-lg border border-score-high/20 bg-score-high/10 p-3">
          <div className="text-xs font-medium text-score-high">
            Несъответствие в сумата на гласовете
          </div>
          <div className="mt-1 text-xs text-score-high">
            При поне една партия: хартиени + машинни ≠ общо
          </div>
        </div>
      ) : null}
    </div>
  );
}
